/**
 * Created by jv on 16/01/2017.
 */
var config = {
  serviceBaseURL: "/services",
  stripe: {}
};

if(__DEVELOPMENT__)
{
  config.stripe.callbackUrl = "STRIPE_TEST_CALLBACK_URL";
  config.stripe.publicApiKey = "STRIPE_TEST_PUBLISHABLE_KEY";
}
else
{
  config.stripe.callbackUrl = "STRIPE_LIVE_CALLBACK_URL";
  config.stripe.publicApiKey = "STRIPE_LIVE_PUBLISHABLE_KEY";
}

module.exports = config;



// WEBPACK FOOTER //
// ./app/js/config/config.js